module.exports = __webpack_public_path__ + "img/new_04_1.b135e94f.jpg";